/* ---- countdown timer ---- */
class CountdownTimer extends HTMLElement {
  constructor() {
    (super(),
      (this.duration = parseInt(this.dataset.duration)),
      this.initTimer(),
      this.updateTimer(),
      "true" === this.dataset.autoPlay && this.playTimer());
  }
  initTimer() {
    ((this.innerHTML = ""),
      (this.minutesSpan = document.createElement("span")));
    let t = document.createTextNode(":");
    ((this.secondsSpan = document.createElement("span")),
      this.append(this.minutesSpan, t, this.secondsSpan));
  }
  updateTimer() {
    let t = parseInt(this.dataset.duration);
    0 === t && (t = 90);
    let e = Math.floor(t / 60),
      i = t % 60;
    ((this.minutesSpan.innerHTML = this.formatNumber(e)),
      (this.secondsSpan.innerHTML = this.formatNumber(i)),
      (this.dataset.duration = t - 1));
  }
  playTimer() {
    this.isPlaying ||
      ((this.isPlaying = !0),
      (this.playInterval = setInterval(() => {
        this.updateTimer();
      }, 1e3)));
  }
  pauseTimer() {
    (clearTimeout(this.playInterval), (this.isPlaying = !0));
  }
  formatNumber(t) {
    return 1 === t.toString().length ? "0" + t : t;
  }
}
customElements.define("countdown-timer", CountdownTimer);

/* ---- date countdown timer ---- */
class DateCountdownTimer extends HTMLElement {
  connectedCallback() {
    if (
      ((this.update = this.update.bind(this)),
      (this.wrapper = this.closest(".countdown-wrapper")),
      !this.wrapper)
    )
      return;
    let t = (this.wrapper.dataset.endTime || "").trim(),
      e = this.wrapper.dataset.timezone,
      i = parseInt(this.wrapper.dataset.utcOffset) || 0;
    if (
      ((this.behavior = this.wrapper.dataset.endBehavior),
      (this.repeatHours = parseInt(this.wrapper.dataset.repeatHours) || 24),
      (this.labels = {
        days: this.wrapper.dataset.labelDays,
        hours: this.wrapper.dataset.labelHours,
        minutes: this.wrapper.dataset.labelMinutes,
        seconds: this.wrapper.dataset.labelSeconds,
      }),
      (this.units = {
        days: "true" === this.wrapper.dataset.showDays,
        hours: "true" === this.wrapper.dataset.showHours,
        minutes: "true" === this.wrapper.dataset.showMinutes,
        seconds: "true" === this.wrapper.dataset.showSeconds,
      }),
      (this.timerStyle = this.dataset.style),
      (this.endTime = this.parseEndTime(t, e, i)),
      !(this.endTime instanceof Date) || isNaN(this.endTime.getTime()))
    ) {
      this.wrapper.style.display = "none";
      return;
    }
    ((this.timer = setInterval(this.update, 1e3)), this.update());
  }
  parseEndTime(t, e, i) {
    let s = t.match(
      /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/,
    );
    if (!s) {
      let n = new Date(t.replace(/-/g, "/"));
      return n;
    }
    let r = parseInt(s[1], 10),
      o = parseInt(s[2], 10) - 1,
      a = parseInt(s[3], 10),
      l = parseInt(s[4], 10),
      d = parseInt(s[5], 10),
      c = parseInt(s[6] || "0", 10);
    if ("fixed" !== e) return new Date(r, o, a, l, d, c);
    {
      let h = Date.UTC(r, o, a, l, d, c) - 36e5 * i;
      return new Date(h);
    }
  }
  update() {
    let t = new Date(),
      e = Math.floor((this.endTime - t) / 1e3);
    if (!isFinite(e)) return;
    if (e <= 0) {
      if ("hide" === this.behavior) {
        ((this.wrapper.style.display = "none"), clearInterval(this.timer));
        return;
      }
      if ("restart" === this.behavior) {
        let i = new Date(this.endTime),
          s = 36e5 * this.repeatHours;
        for (; i <= t;) i = new Date(i.getTime() + s);
        ((this.endTime = i), (e = Math.floor((this.endTime - t) / 1e3)));
      } else if ("next_day" === this.behavior) {
        let n = new Date(this.endTime);
        for (; n <= t;) n.setDate(n.getDate() + 1);
        ((this.endTime = n), (e = Math.floor((this.endTime - t) / 1e3)));
      }
    }
    let r = Math.floor(e / 86400),
      o = Math.floor((e % 86400) / 3600),
      a = Math.floor((e % 3600) / 60),
      l = e % 60,
      d = { days: r, hours: o, minutes: a, seconds: l };
    Object.keys(this.units).forEach((t) => {
      if (!this.units[t]) return;
      let e = this.querySelector(
        `[aria-label="${"days" === t ? "Day" : "hours" === t ? "Hour" : "minutes" === t ? "Minute" : "Second"}"]`,
      );
      if (!e) return;
      let i = e.querySelector(".countdown-timer__number");
      if (!i) return;
      let s = String(d[t]).padStart(2, "0");
      ("4" === this.timerStyle
        ? ((i.innerHTML = ""),
          s.split("").forEach((t) => {
            let e = document.createElement("span");
            ((e.className = "countdown-timer__digit"),
              (e.textContent = t),
              i.appendChild(e));
          }))
        : (i.textContent = s),
        i.setAttribute("aria-label", `${d[t]} ${this.labels[t]}`));
    });
  }
  disconnectedCallback() {
    clearInterval(this.timer);
  }
}
customElements.define("date-countdown-timer", DateCountdownTimer);
